var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDataSource = function SvgDataSource(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 44L15.8632 32.6085H20.4843V22.75H27.5155V32.6085H32.1366L23.9999 44Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1977 13.7675C38.8041 9.60875 35.2907 6.34375 31.0312 6.34375C29.6328 6.34375 28.2732 6.71109 27.0441 7.41266C25.0483 5.23141 22.2857 4 19.3125 4C13.7575 4 9.19367 8.31672 8.79313 13.7709C6.01219 14.7426 4 17.3953 4 20.4062C4 24.2835 7.23211 27.4375 11.1094 27.4375H18.1406V20.4062H29.8594V27.4375H36.8906C40.7679 27.4375 44 24.2835 44 20.4062C44 17.393 41.9855 14.7369 39.1977 13.7675Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.8632,
    y1: 22.75,
    x2: 31.1053,
    y2: 22.0344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B568"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 4,
    y1: 4,
    x2: 41.141,
    y2: 0.113785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B568"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDataSource);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dataSource.39be0a8cbdc2140f012051e513b9deb2.svg";